import { render, staticRenderFns } from "./tag-select.vue?vue&type=template&id=78b00769&scoped=true&"
import script from "./tag-select.vue?vue&type=script&lang=js&"
export * from "./tag-select.vue?vue&type=script&lang=js&"
import style0 from "./tag-select.vue?vue&type=style&index=0&id=78b00769&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b00769",
  null
  
)

export default component.exports